import { createFileRoute } from "@tanstack/react-router"
import LanguagesPage from "@/app/settings/preferences/languages/page"

export const Route = createFileRoute("/settings/preferences/languages")({
  component: LanguagesPage,
})
